import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FullScreenSVG = function FullScreenSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28 2H4a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V4a2 2 0 00-2-2zM13.71 19.71L9.42 24H12a1 1 0 010 2H7a.69.69 0 01-.25 0 .37.37 0 01-.14 0 .94.94 0 01-.53-.53.37.37 0 010-.14A.69.69 0 016 25v-5a1 1 0 012 0v2.58l4.29-4.29a1 1 0 011.42 1.42zm0-6a1 1 0 01-1.42 0L8 9.42V12a1 1 0 01-2 0V7a.69.69 0 010-.25.37.37 0 010-.14.94.94 0 01.53-.53.37.37 0 01.14 0A.69.69 0 017 6h5a1 1 0 010 2H9.42l4.29 4.29a1 1 0 010 1.42zM26 25a.69.69 0 010 .25.37.37 0 010 .14.94.94 0 01-.53.53.37.37 0 01-.14 0A.69.69 0 0125 26h-5a1 1 0 010-2h2.58l-4.29-4.29a1 1 0 011.42-1.42L24 22.58V20a1 1 0 012 0zm0-13a1 1 0 01-2 0V9.42l-4.29 4.29a1 1 0 01-1.42 0 1 1 0 010-1.42L22.58 8H20a1 1 0 010-2h5a.69.69 0 01.25 0 .37.37 0 01.14 0 .94.94 0 01.53.53.37.37 0 010 .14A.69.69 0 0126 7z"
  }));
};
FullScreenSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FullScreenSVG);